import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */

const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#7341B5',
  layout: 'top',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Like the Sound of You',
  pwa: true,
  logo: '/logo.png',
  iconfontUrl: '',
  token: {},
  splitMenus: false,
};

export default Settings;
